import React from 'react'

import { IMAGE } from '@ui-kit/assets/images/index.web'
import Icon from '@ui-kit/components/SvgIcon/index.web'
import type { TableRowData } from '@ui-kit/components/Table/types'
import { body2 } from '@ui-kit/core/typography'

interface Props {
  rowContentValue: TableRowData
  isDescriptionExpanded: boolean
  className: string
}

const TableRowContentValue = (props: Props) => {
  const renderValue = () => {
    switch (props.rowContentValue.type) {
      case 'boolean':
        return (
          <Icon
            imgSrc={
              props.rowContentValue.value === 'true'
                ? IMAGE.icons.small.checkBoxSmallGreen_24
                : IMAGE.icons.small.crossSmallRed_24
            }
          />
        )
      case 'string':
        return (
          <span className={body2({ bold: props.isDescriptionExpanded })}>
            {props.rowContentValue.value}
          </span>
        )
      default:
        throw new Error(`Assertion: can't render "${props.rowContentValue.type}" type of value`)
    }
  }

  return <div className={props.className}>{renderValue()}</div>
}

export default TableRowContentValue
